import {UserLevel} from '@netx/core-user/constants';

export const MINIMUM_USER_LEVEL = UserLevel.MANAGER;
